module.exports = __webpack_public_path__ + "static/media/keyboard_backspace-24px.4d98b6c0.svg";